import { ParsedURL } from 'shared/utils/urls';
import { debug } from 'shared/utils/debug';
import { replaceMacros } from 'shared/utils/urls/misc';
import { processClickTagUrl } from 'shared/utils/urls/processClickTagUrl';
/**
 * Fire click tracking by opening new window with the given Url
 * In Proof, it sends a message instead
 */
export var fireClickTracking = function (url) {
    // Final URL is determined at time of click to account for changes since
    // last render. UTM overrides, query params, etc, may have been updated.
    var processedUrl = replaceMacros(url);
    processedUrl = processClickTagUrl(processedUrl);
    // Do not open new window in proof view, but broadcast clickTag URL instead
    var isInProof = !!new ParsedURL().queryParam('proof');
    if (isInProof && window.iframeAdToProof) {
        window.iframeAdToProof.broadcast({
            type: 'clickTag',
            msg: processedUrl,
        });
        return;
    }
    open(processedUrl);
};
/**
 * If we are in a mobile open, use the MRAID opener. Otherwise,
 * use the standard `window.open()` provided by browsers.
 */
var open = function (url) {
    return window.mraid ? window.mraid.open(url) : window.open(url, '_blank');
};
/**
 * Fire Pixel Impression Tracking
 * generate an image with the tracking url
 */
export var firePixelTracking = function (src) {
    if (!src) {
        return;
    }
    var processedSrc = replaceMacros(src);
    var img = document.createElement('img');
    var query = processedSrc.indexOf('?') !== -1 ? '&' : '?';
    // append our own cache buster so that we can fire these pixels off
    // multiple times in one viewing session
    var imgSrc = processedSrc + query + 'c_buster=' + Date.now();
    img.src = imgSrc;
    debug('track', imgSrc);
};
